import { useEffect, useRef, useState } from "react";
import { usePermission } from "../../../context/PermissionContext";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useAuth } from "../../../context/AuthProvider";
import { useShowAlert } from "../../../context/AlertContext";
import DateConverter from "@heartinz/date_and_time_processor";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { getPurchaseAmount } from "@heartinz/finance";
import GetServerLiveTime from "../../../constants/GetServerLiveTime";
import handleError from "../../../constants/handleError";
import Messages from "../../../constants/Messages";
import { CircularProgress } from "@mui/material";
import uRLs from "../../../utils/baseUtils";
import { toPrimaryQuantity, toSecondaryQuantity } from "@heartinz/finance";
import { AddIcon, XIcon } from "../../../constants/Icons";

const AddStockModel = ({
  onclose,
  onData,
  stockData,
  onUpdate,
  onStockAdd,
  onStockCreate,
  finalLand,
}) => {
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [purchaseLock, setPurchaseLock] = useState("WITHTAX");
  // values: "WITH_TAX" | "WITHOUT_TAX"
  const [error, setErrors] = useState("");
  // const [isSelectedRadio, setSelectedRadio] = useState("SALEPRICE");
  const { isUser } = useAuth();
  const serverTime = GetServerLiveTime();
  const showAlert = useShowAlert();
  const { viewOption } = usePermission();
  const searchRef = useRef(null);
  const productMrpRef = useRef(null);
  const productSalepriceRef = useRef(null);
  const productTaxpercentageRef = useRef(null);
  const productBasepriceRef = useRef(null);
  const productMdateRef = useRef(null);
  const purchasewithtaxref = useRef(null);
  const purchasewithouttaxRef = useRef(null);
  const manufacturedateRefs = useRef(null);
  const expiredateRefs = useRef(null);
  const addStockBtnRef = useRef(null);
  const popupMrpInputRef = useRef(null);
  const [showMrpPopup, setShowMrpPopup] = useState(false);
  const [popupMrpValue, setPopupMrpValue] = useState("");
  const [popupMrpStyle, setPopupMrpStyle] = useState({});

  const [selectedProduct, setselectedProduct] = useState(null);
  const [isProductData, setProductData] = useState({
    mrp: 0,
    saleprice: 0,
    taxpercentage: 0,
    discount: 0,
    baseprice: 0,
    taxamount: 0,
    quantity: 0,
    purchaseWithTax: 0,
    purchaseWithoutTax: 0,
    isLock: "SALEPRICE",
    purchaseLock: "WITHTAX",
    ratePerUnit: 0,
    isSecondaryUnit: false,
  });
  const [addToStock, setAddToStock] = useState(true); // default ON
  const unitConfig = selectedProduct?.unitConfig || {};
  const { primaryUnitCode, secondaryUnitCode } = unitConfig;
  const [selectedUnit, setSelectedUnit] = useState(primaryUnitCode || "");
  const iso = serverTime.toISOString();
  const indiaTime = DateConverter.convertToTimeZone(iso, isUser?.timezone);

  const [manufacturedate, setMDate] = useState("");
  const [expiredate, setEDate] = useState("");
  const [expireMinDate, setExpireMinDate] = useState(iso);
  const [openMfgDate, setOpenMfgDate] = useState(false);
  const [openExpDate, setOpenExpDate] = useState(false);

  // const handleMDateChange = ([selectedDate]) => {
  //   const iso = selectedDate.toISOString();
  //   const indiaTime = DateConverter.convertToTimeZone(iso, isUser?.timezone);
  //   setMDate(indiaTime);
  //   setExpireMinDate(indiaTime);
  // };

  const handleMDateChange = (selectedDate) => {
    if (!selectedDate) return;

    const iso = selectedDate.toISOString();
    const indiaTime = DateConverter.convertToTimeZone(iso, isUser?.timezone);

    setMDate(indiaTime);
    setExpireMinDate(indiaTime);

    setProductData((prev) => ({
      ...prev,
      manufacturedate: indiaTime,
    }));
  };

  // const handleEDateChange = ([selectedDate]) => {
  //   const iso = selectedDate.toISOString();
  //   const indiaTime = DateConverter.convertToTimeZone(iso, isUser?.timezone);
  //   setEDate(indiaTime);
  // };

  const handleEDateChange = (selectedDate) => {
    if (!selectedDate) return;

    const iso = selectedDate.toISOString();
    const indiaTime = DateConverter.convertToTimeZone(iso, isUser?.timezone);

    setEDate(indiaTime);

    setProductData((prev) => ({
      ...prev,
      expiredate: indiaTime,
    }));
  };

  const handleSelectSuggestion = async (product, finalLand) => {
    try {
      const fullProduct = product;
      setselectedProduct(fullProduct);
      setProductData({
        ...fullProduct,
        mrp: CurrencyConverter.toCurrency(fullProduct.mrp || 0, "INR"),
        saleprice: CurrencyConverter.toCurrency(
          fullProduct.saleprice || 0,
          "INR",
        ),
        taxpercentage: fullProduct.taxpercentage,
        discount: CurrencyConverter.toCurrency(
          fullProduct.discount || 0,
          "INR",
        ),
        baseprice: CurrencyConverter.toCurrency(
          fullProduct.baseprice || 0,
          "INR",
        ),
        taxamount: CurrencyConverter.toCurrency(
          fullProduct.taxamount || 0,
          "INR",
        ),
        quantity: 0,
        isLock: fullProduct.isLock,
        isStock: fullProduct.isStock,
        purchaseamount: CurrencyConverter.toCurrency(
          fullProduct.purchaseamount || 0,
          "INR",
        ),
      });
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleCalculate = (data, isUserInput) => {
    try {
      // ✅ 1. Normalize input (convert once)
      const toSub = (val) =>
        Number(CurrencyConverter.toSubunit(val || 0, "INR")) || 0;

      const toCur = (val) => CurrencyConverter.toCurrency(val || 0, "INR");

      const numeric = {
        mrp: toSub(data.mrp),
        saleprice: toSub(data.saleprice),
        baseprice: toSub(data.baseprice),
        purchaseWithTax: toSub(data.purchaseWithTax),
        purchaseWithoutTax: toSub(data.purchaseWithoutTax),
        quantity: data?.isSecondaryUnit
          ? Number(
              toPrimaryQuantity(
                parseFloat(data.quantity) || 0,
                selectedProduct?.unitConfig || {},
              )?.primaryQty,
            )
          : parseFloat(data.quantity) || 1,

        tax: parseInt(data.taxpercentage) || 0,
      };
      // console.log(data);
      // console.log("Normalized Input:", numeric);

      // ✅ 2. Safety rules
      if (numeric.saleprice > numeric.mrp) {
        numeric.mrp = numeric.saleprice;
      }

      const lock = data.isLock;
      const purchaseLockType = data.totalPurchaseAmountLock || purchaseLock;

      // ✅ 3. Prepare payload
      const payload = {
        mrp: numeric.mrp,
        salePricePerUnit: numeric.saleprice,
        basePricePerUnit: numeric.baseprice,
        lock,
        taxPercent: numeric.tax,
        quantity: numeric.quantity,
        totalPurchaseAmountWithTax: numeric.purchaseWithTax,
        totalPurchaseAmountWithOutTax: numeric.purchaseWithoutTax,
        totalPurchaseAmountLock: purchaseLockType,
        unitConfig:
          selectedProduct?.unitConfig &&
          Object.keys(selectedProduct.unitConfig).length > 0
            ? selectedProduct.unitConfig
            : undefined,
      };
      // console.log("Calculation Payload:", payload);

      // ✅ 4. Calculation (single call)
      const result = getPurchaseAmount(
        payload.mrp,
        payload.salePricePerUnit,
        payload.basePricePerUnit,
        payload.lock,
        payload.taxPercent,
        payload.quantity,
        payload.totalPurchaseAmountWithTax,
        payload.totalPurchaseAmountWithOutTax,
        payload.totalPurchaseAmountLock,
        payload.unitConfig,
      );

      const { saleAmountList, purchaseAmountList } = result;
      // console.log("Calculation Result:", result);

      // ✅ 5. Compute purchaseamount based on lock
      const purchaseamount =
        purchaseLockType === "WITHTAX"
          ? purchaseAmountList.lineTotalPurchasePriceWithTax
          : purchaseAmountList.lineTotalPurchasePriceWithoutTax;

      // ✅ 6. Update state (respect locks)
      setProductData((prev) => ({
        ...prev,

        // SALE
        mrp: toCur(saleAmountList.mrp),

        saleprice:
          lock === "SALEPRICE"
            ? prev.saleprice
            : toCur(saleAmountList.salePrice),

        baseprice:
          lock === "BASEPRICE"
            ? prev.baseprice
            : toCur(saleAmountList.basePrice),

        taxamount: toCur(saleAmountList.taxAmount),
        discount: toCur(saleAmountList.discount),
        ratePerUnit: toCur(purchaseAmountList.purchasePriceWithTax),

        // PURCHASE
        purchaseWithTax:
          purchaseLockType === "WITHTAX"
            ? isUserInput
              ? prev.purchaseWithTax
              : toCur(purchaseAmountList.lineTotalPurchasePriceWithTax)
            : toCur(purchaseAmountList.lineTotalPurchasePriceWithTax),

        purchaseWithoutTax:
          purchaseLockType === "WITHOUTTAX"
            ? isUserInput
              ? prev.purchaseWithoutTax
              : toCur(purchaseAmountList.lineTotalPurchasePriceWithoutTax)
            : toCur(purchaseAmountList.lineTotalPurchasePriceWithoutTax),

        // ✅ critical for validation

        purchaseamount: purchaseamount,
      }));
    } catch (error) {
      console.error("CALC ERROR:", error);
      showAlert("warning", error.message || Messages.ERROR.INVALID_INPUT);
    }
  };

  const handleChange = (e) => {
    setErrors("");

    const { name, value } = e.target;

    // ✅ Common validators
    const isDecimal = /^$|^\d*\.?\d{0,2}$/;
    const isInteger = /^[0-9]*$/;

    let inputValue = value;

    // ✅ 1. Field-level validation
    if (
      [
        "mrp",
        "saleprice",
        "baseprice",
        "purchaseWithTax",
        "purchaseWithoutTax",
      ].includes(name)
    ) {
      if (!isDecimal.test(value)) return;
    }

    if (name === "quantity") {
      if (uRLs.UNIT === "true" && selectedProduct?.unitConfig) {
        const isSecondary =
          selectedUnit === selectedProduct?.unitConfig?.secondaryUnitCode;

        if (isSecondary) {
          // secondary unit -> allow 1 decimal
          if (!/^\d*\.?\d{0,1}$/.test(value)) {
            return;
          }
        } else {
          // primary unit -> allow 3 decimals
          if (!/^\d*\.?\d{0,3}$/.test(value)) {
            return;
          }
        }
      } else {
        // no unit config -> integer only
        if (!/^\d*$/.test(value)) {
          return;
        }
      }
    }

    if (name === "taxpercentage") {
      const allowed = [0, 5, 12, 18, 24];
      inputValue = allowed.includes(Number(value)) ? value : 0;
    }

    // ✅ 2. Build updated state
    let updatedData = {
      ...isProductData,
      [name]: inputValue,
    };

    // ✅ 3. Auto lock switching (clean)
    if (name === "saleprice" || name === "baseprice") {
      updatedData.isLock = name === "saleprice" ? "SALEPRICE" : "BASEPRICE";
    }

    // ✅ 4. Purchase lock handling (SYNC + STATE)
    if (name === "purchaseWithTax" || name === "purchaseWithoutTax") {
      const lockType = name === "purchaseWithTax" ? "WITHTAX" : "WITHOUTTAX";

      updatedData.totalPurchaseAmountLock = lockType;
      setPurchaseLock(lockType); // ✅ sync radio state
    }

    // ✅ 5. Update state first (single source of truth)
    setProductData(updatedData);

    // ✅ 6. Avoid unnecessary calculations (important UX fix)
    const shouldCalculate = inputValue !== "" && inputValue !== ".";

    const isPurchaseField =
      name === "purchaseWithTax" || name === "purchaseWithoutTax";

    if (shouldCalculate) {
      handleCalculate(updatedData, { isUserInput: isPurchaseField });
    }
  };

  const handleRadioChange = (inputName) => {
    // setSelectedRadio(inputName);
    setProductData((prev) => ({
      ...prev,
      isLock: inputName,
    }));
  };

  const isValidDate = (date) => {
    const d = new Date(date);
    return !isNaN(d.getTime());
  };

  const onAdd = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    let finalQty = Number(isProductData.quantity || 0);

    const isSecondary =
      selectedUnit === selectedProduct?.unitConfig?.secondaryUnitCode;

    // ✅ Convert secondary qty -> primary qty
    if (isSecondary) {
      finalQty = toPrimaryQuantity(
        finalQty,
        selectedProduct?.unitConfig || {},
      )?.primaryQty;
    }

    const updatedData = {
      ...isProductData,

      // ✅ converted qty for API
      quantity: Number(finalQty),

      // ✅ actual entered qty (optional)
      enteredQuantity: Number(isProductData.quantity),

      // ✅ selected unit
      selectedUnit,

      // ✅ flag
      isSecondaryUnit: isSecondary,

      unitConfig: selectedProduct?.unitConfig,

      addToStock,
    };

    onStockAdd(updatedData, selectedProduct);

    handleClose();
  };

  const resetForm = () => {
    setProductData({
      mrp: 0,
      saleprice: 0,
      taxpercentage: 0,
      discount: 0,
      baseprice: 0,
      taxamount: 0,
      quantity: 0,
      purchaseWithTax: 0,
      purchaseWithoutTax: 0,
      isLock: "SALEPRICE",
      purchaseLock: "WITHTAX",
      ratePerUnit: 0,
    });
    setErrors("");
    searchRef.current?.focus();
    setselectedProduct(null);
    // setSelectedRadio("SALEPRICE");
    setEDate(null);
    setMDate(null);
  };

  const validateForm = () => {
    const errors = {};
    // if (!selectedProduct || !selectedProduct._id) {

    if (!selectedProduct) {
      errors.productid = Messages.ERROR.PRODUCTID_EMPTY;
    } else if (
      isProductData.saleprice === undefined ||
      isProductData.saleprice === null ||
      isProductData.saleprice === ""
    ) {
      errors.saleprice = Messages.ERROR.SALEPRICE_EMPTY;
      productSalepriceRef.current?.focus();
    } else if (
      isProductData.saleprice &&
      !/^\d*\.?\d{0,2}$/.test(isProductData.saleprice)
    ) {
      errors.saleprice = Messages.ERROR.INVALID_INPUT;
      productSalepriceRef.current?.focus();
    } else if (
      isProductData.taxpercentage === undefined ||
      isProductData.taxpercentage === null ||
      isProductData.taxpercentage === ""
    ) {
      errors.taxpercentage = Messages.ERROR.TAX_EMPTY;
      productTaxpercentageRef.current?.focus();
    } else if (
      isProductData.taxpercentage &&
      !/^[0-9]*$/.test(isProductData.taxpercentage)
    ) {
      errors.taxpercentage = Messages.ERROR.INVALID_INPUT;
      productTaxpercentageRef.current?.focus();
    } else if (
      isProductData.baseprice === undefined ||
      isProductData.baseprice === null ||
      isProductData.baseprice === ""
    ) {
      errors.baseprice = Messages.ERROR.BASEPRICE_EMPTY;
      productBasepriceRef.current?.focus();
    } else if (
      isProductData.baseprice &&
      !/^\d*\.?\d{0,2}$/.test(isProductData.baseprice)
    ) {
      errors.baseprice = Messages.ERROR.INVALID_INPUT;
      productBasepriceRef.current?.focus();
    } else if (
      isProductData.taxamount === undefined ||
      isProductData.taxamount === null ||
      isProductData.taxamount === ""
    ) {
      errors.taxamount = Messages.ERROR.TAXAMOUNT_EMPTY;
    } else if (
      isProductData.taxamount &&
      !/^\d*\.?\d{0,2}$/.test(isProductData.taxamount)
    ) {
      errors.taxamount = Messages.ERROR.INVALID_INPUT;
    } else if (
      isProductData.quantity === undefined ||
      isProductData.quantity === null ||
      isProductData.quantity === ""
    ) {
      errors.quantity = Messages.ERROR.STOCK_EMPTY;
      productMdateRef.current?.focus();
    } else if (
      isProductData.quantity &&
      (() => {
        if (uRLs.UNIT === "true" && selectedProduct?.unitConfig) {
          const isSecondary =
            selectedUnit === selectedProduct?.unitConfig?.secondaryUnitCode;

          return isSecondary
            ? !/^\d*\.?\d{0,1}$/.test(isProductData.quantity)
            : !/^\d*\.?\d{0,3}$/.test(isProductData.quantity);
        }

        return !/^\d+$/.test(isProductData.quantity);
      })()
    ) {
      errors.quantity = Messages.ERROR.INVALID_INPUT;
      productMdateRef.current?.focus();
    } else if (parseFloat(isProductData.quantity || 0) <= 0) {
      errors.quantity = Messages.ERROR.STOCK_INVALID;
      productMdateRef.current?.focus();
    } else if (!isProductData.purchaseamount) {
      errors.purchaseamount = "Purchase amount is required";
    }

    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      const firstErrorField = Object.keys(errors)[0];
      switch (firstErrorField) {
        case "saleprice":
          productSalepriceRef.current?.focus();
          break;
        case "taxpercentage":
          productTaxpercentageRef.current?.focus();
          break;
        case "baseprice":
          productBasepriceRef.current?.focus();
          break;
        case "productid":
          searchRef.current?.focus();
          break;
        default:
          break;
      }
    }
    return Object.keys(errors).length === 0;
  };

  const handleClose = async () => {
    resetForm();
    onclose();
  };

  const handleEnterKey = (e, fieldName, nextRef = null, isLast = false) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextRef === productMrpRef) {
        // const rect = nextRef.current.getBoundingClientRect();
        // setPopupMrpStyle({
        //   position: "absolute",
        //   top: `${rect.top + window.scrollY}px`,
        //   left: `${rect.left + window.scrollX}px`,
        //   width: `${rect.width}px`,
        //   zIndex: 10000,
        // });
        setPopupMrpStyle(getMrpPopupStyle(nextRef));
        setPopupMrpValue(isProductData.mrp);
        setShowMrpPopup(true);
      }
      if (isLast) {
        onAdd(e);
      } else {
        const nextInput =
          nextRef?.current?.input ||
          nextRef?.current?.flatpickr?.input ||
          nextRef?.current?.querySelector?.("input") ||
          nextRef?.current;

        if (nextInput && typeof nextInput.focus === "function") {
          nextInput.focus();
        } else {
          console.warn("Cannot focus nextRef:", nextRef);
        }
      }
    }
  };

  const getMrpPopupStyle = (inputRef) => {
    const scrollParent = inputRef.current.closest(".modal-body");
    if (!scrollParent) return {};
    return {
      position: "absolute",
      top: "208px",
      left: "16px",
      width: "130px",
      zIndex: 10000,
    };
  };

  useEffect(() => {
    if (onData) {
      handleSelectSuggestion(onData, finalLand);
    }
  }, [onData]);

  useEffect(() => {
    return () => {
      localStorage.setItem("lastMultiplier", 1);
    };
  }, []);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onclose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onclose]);

  useEffect(() => {
    if (isUser.stype === "MAIN") {
      productMrpRef.current?.focus();
    } else {
      productMdateRef.current?.focus();
    }
  }, [selectedProduct]);

  useEffect(() => {
    if (selectedProduct?.unitConfig) {
      setSelectedUnit(selectedProduct.unitConfig.primaryUnitCode);
    }
  }, [selectedProduct]);

  const stopEventPropagation = (e) => e.stopPropagation();

  const hasUnit =
    uRLs.UNIT === "true" && unitConfig && unitConfig.primaryUnitCode;

  return (
    <>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="CustomerModal"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
        // onClick={handleClose}
        style={{ display: "block" }}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
          onClick={stopEventPropagation}
        >
          <div className="modal-content" style={{ position: "relative" }}>
            <div className="modal-header">
              <h6 className="modal-title">Add Item</h6>
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body bg-light">
              <div className="row g-3">
                <div className="col-lg-6">
                  <div className="card h-100">
                    <div className="card-body">
                      <div className="col-lg-12 mb-2">
                        <div className="card shadow-none border-blue mb-0">
                          <div className="card-header bg-light-blue p-2 d-flex justify-content-between align-items-center">
                            <div className="mb-0">Product info</div>
                            {selectedProduct?.title && (
                              <div>
                                {/* <button
                                  type="button"
                                  className="bg-light-blue rounded  shadow-none border-0"
                                  onClick={() => openEditModal(selectedProduct)}
                                >
                                  <i className="ng ng-ng-edit-icon"></i>
                                </button> */}
                              </div>
                            )}
                          </div>
                          <div className="card-body p-2">
                            {selectedProduct?.title ? (
                              <div>
                                {/* <p className="mb-1">
                                               Title :{" "}
                                               <span className="fw-600">
                                                 {selectedProduct?.title}
                                               </span>
                                             </p>
                                             <p className="mb-1">
                                               HSN :{" "}
                                               {selectedProduct?.hsnsac ? (
                                                 <span className="fw-600">
                                                   {selectedProduct?.hsnsac}
                                                 </span>
                                               ) : (
                                                 <>-</>
                                               )}
                                             </p> */}
                                {/* <p className="mb-1">
                                               SalePrice :{" "}
                                               <span className="fw-600">
                                                 ₹
                                                 {CurrencyConverter.toCurrency(
                                                   selectedProduct?.saleprice || 0,
                                                   "INR"
                                                 )}{" "}
                                               </span>
                                             </p> */}
                                <div className="d-flex ">
                                  <div
                                    className="mb-1 d-flex  gap-2"
                                    style={{ flexBasis: "100%" }}
                                  >
                                    <span className="fw-semibold text-muted">
                                      Title:
                                    </span>
                                    {selectedProduct?.title ? (
                                      <span className="fw-600">
                                        {selectedProduct?.title}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                </div>
                                <div className="d-flex ">
                                  <div
                                    className="mb-1 d-flex align-items-center gap-2"
                                    style={{ flexBasis: "50%" }}
                                  >
                                    <span className="fw-semibold text-muted">
                                      SKU Code:
                                    </span>
                                    {selectedProduct?.code ? (
                                      <span className="badge rounded-pill bg-label-navy">
                                        {selectedProduct?.code}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                  <div
                                    className="mb-1 d-flex align-items-center gap-2"
                                    style={{ flexBasis: "50%" }}
                                  >
                                    <span className="fw-semibold text-muted">
                                      HSN:
                                    </span>
                                    {selectedProduct?.hsnsac ? (
                                      <span className="badge rounded-pill bg-label-retro">
                                        {selectedProduct.hsnsac}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                </div>
                                <div className="d-flex ">
                                  <div
                                    className="mb-1 d-flex align-items-center gap-2"
                                    style={{ flexBasis: "50%" }}
                                  >
                                    <span className="fw-semibold text-muted">
                                      Brand:
                                    </span>
                                    {selectedProduct?.brandId ? (
                                      <span className="badge bg-label-kids">
                                        {selectedProduct?.brandId}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                  <div
                                    className="mb-1 d-flex align-items-center gap-2"
                                    style={{ flexBasis: "50%" }}
                                  >
                                    <span className="fw-semibold text-muted">
                                      Total Stock Left:
                                    </span>
                                    {selectedProduct?.totalStockLeft ? (
                                      <span className="badge bg-label-space">
                                        {selectedProduct.totalStockLeft}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                </div>
                                <div className="d-flex ">
                                  <div
                                    className="mb-1 d-flex align-items-center gap-2"
                                    style={{ flexBasis: "50%" }}
                                  >
                                    <span className="fw-semibold text-muted">
                                      Note:
                                    </span>
                                    {selectedProduct?.note ? (
                                      <span className="badge bg-label-sun">
                                        {selectedProduct?.note}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                  {/* {uRLs.UNIT === "true" && (
                                    <div
                                      className="mb-2 d-flex align-items-center gap-2"
                                      style={{ flexBasis: "50%" }}
                                    >
                                      <span className="fw-semibold text-muted">
                                        Unit:
                                      </span>
                                      {defaultConversion?.unitName ? (
                                        <span className="badge rounded-pill btn-unit">
                                          {defaultConversion?.unitName} (
                                          {defaultConversion.unitCode})
                                        </span>
                                      ) : (
                                        "-"
                                      )}
                                    </div>
                                  )} */}
                                </div>
                              </div>
                            ) : (
                              <p className="mb-0 text-muted">
                                No products has been selected
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                      {/* {selectedProduct ? ( */}
                      <div className="col-12 border-top ">
                        <div className="fw-600 mt-2">
                          Amount{" "}
                          {selectedUnit ? (
                            <span className="">
                              (Per {selectedProduct.unitConfig.primaryUnitCode})
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="row g-2 mt-1">
                        <div className="col-lg-4">
                          <label htmlFor="mrp" className="form-label">
                            {" "}
                            MRP{" "}
                          </label>
                          {showMrpPopup && (
                            <input
                              type="text"
                              ref={popupMrpInputRef}
                              value={popupMrpValue}
                              onChange={(e) => {
                                const val = e.target.value;

                                // Regex: only digits, optional one dot, up to 2 decimals
                                const regex = /^\d+(\.\d{0,2})?$/;

                                if (val === "" || regex.test(val)) {
                                  setPopupMrpValue(val);
                                  setProductData((prev) => ({
                                    ...prev,
                                    mrp: val,
                                  }));
                                  handleCalculate({
                                    ...isProductData,
                                    mrp: val,
                                  });
                                }
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  setShowMrpPopup(false);
                                  setTimeout(() => {
                                    productSalepriceRef?.current?.focus();
                                  }, 0);
                                }
                              }}
                              onBlur={() => setShowMrpPopup(false)}
                              autoFocus
                              onFocus={(e) => e.target.select()}
                              // style={popupMrpStyle}
                              className="form-control"
                            />
                          )}
                          {!showMrpPopup && (
                            <input
                              type="text"
                              className="form-control"
                              name="mrp"
                              autoComplete="off"
                              ref={productMrpRef}
                              value={isProductData.mrp}
                              onFocus={(e) => e.target.select()}
                              onChange={handleChange}
                              disabled={
                                isUser.stype !== "MAIN" &&
                                isProductData?.isStock
                              }
                              onKeyDown={(e) =>
                                handleEnterKey(e, "mrp", productSalepriceRef)
                              }
                              onClick={() => {
                                // const rect =
                                //   productMrpRef.current.getBoundingClientRect();
                                setPopupMrpStyle(
                                  getMrpPopupStyle(productMrpRef),
                                );
                                setPopupMrpValue(isProductData.mrp);
                                setShowMrpPopup(true);
                              }}
                            />
                          )}
                          {error.mrp && (
                            <div className="invalid-feedback">{error.mrp}</div>
                          )}
                        </div>

                        <div className="col-lg-4">
                          <label htmlFor="saleprice" className="form-label">
                            Sale Price <span className="text-danger">*</span>
                          </label>
                          <div className="input-container position-relative">
                            <input
                              type="text"
                              name="saleprice"
                              autoComplete="off"
                              ref={productSalepriceRef}
                              value={isProductData.saleprice}
                              className="form-control"
                              onFocus={(e) => e.target.select()}
                              onClick={() => handleRadioChange("SALEPRICE")}
                              style={{ paddingLeft: "30px" }}
                              disabled={
                                isUser.stype !== "MAIN" &&
                                isProductData?.isStock
                              }
                              onChange={handleChange}
                              onKeyDown={(e) =>
                                handleEnterKey(
                                  e,
                                  "saleprice",
                                  productTaxpercentageRef,
                                )
                              }
                            />
                            <input
                              type="radio"
                              name="priceLock"
                              checked={isProductData?.isLock === "SALEPRICE"}
                              onChange={() => handleRadioChange("SALEPRICE")}
                              className="position-absolute"
                              style={{
                                top: "50%",
                                left: "10px",
                                transform: "translateY(-50%)",
                                zIndex: 2,
                              }}
                            />
                          </div>
                          {error.saleprice && (
                            <div className="invalid-feedback">
                              {error.saleprice}
                            </div>
                          )}
                        </div>

                        <div className="col-lg-4">
                          <label htmlFor="taxpercentage" className="form-label">
                            Tax(%) <span className="text-danger">*</span>
                          </label>
                          <select
                            name="taxpercentage"
                            className="form-control"
                            ref={productTaxpercentageRef}
                            value={isProductData.taxpercentage}
                            disabled={
                              isUser.stype !== "MAIN" && isProductData?.isStock
                            }
                            onChange={handleChange}
                            onKeyDown={(e) =>
                              handleEnterKey(
                                e,
                                "taxpercentage",
                                productBasepriceRef,
                              )
                            }
                          >
                            <option value="0">0</option>
                            <option value="5">5</option>
                            <option value="12">12</option>
                            <option value="18">18</option>
                            <option value="24">24</option>
                          </select>
                        </div>

                        <div className="col-lg-4">
                          <label htmlFor="discount" className="form-label">
                            Discount
                          </label>
                          <input
                            readOnly=""
                            type="text"
                            name="discount"
                            autoComplete="off"
                            value={isProductData.discount}
                            className="form-control"
                            disabled
                          />
                        </div>

                        <div className="col-lg-4">
                          <label htmlFor="baseprice" className="form-label">
                            Base Price
                          </label>
                          <div className="input-container position-relative">
                            <input
                              type="text"
                              name="baseprice"
                              autoComplete="off"
                              ref={productBasepriceRef}
                              onClick={() => handleRadioChange("BASEPRICE")}
                              onChange={handleChange}
                              value={isProductData.baseprice}
                              onFocus={(e) => e.target.select()}
                              disabled={
                                isUser.stype !== "MAIN" &&
                                isProductData?.isStock
                              }
                              className="form-control"
                              style={{ paddingLeft: "30px" }}
                              onKeyDown={(e) =>
                                handleEnterKey(e, "baseprice", productMdateRef)
                              }
                            />
                            <input
                              type="radio"
                              name="priceLock"
                              checked={isProductData?.isLock === "BASEPRICE"}
                              onChange={() => handleRadioChange("BASEPRICE")}
                              className="position-absolute"
                              style={{
                                top: "50%",
                                left: "10px",
                                transform: "translateY(-50%)",
                                zIndex: 2,
                              }}
                            />
                          </div>
                          {error.baseprice && (
                            <div className="invalid-feedback">
                              {error.baseprice}
                            </div>
                          )}
                        </div>

                        <div className="col-lg-4">
                          <label htmlFor="taxamount" className="form-label">
                            Tax Amount
                          </label>
                          <input
                            readOnly=""
                            type="text"
                            name="taxamount"
                            autoComplete="off"
                            className="form-control"
                            value={isProductData.taxamount}
                            disabled
                          />
                        </div>

                        {viewOption(
                          "stockSettings",
                          "isManufactureAndExpiryDates",
                        ) && (
                          <>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <div className="col-lg-6">
                                <label
                                  htmlFor="manufacturedate"
                                  className="form-label"
                                >
                                  Manufacture Date
                                </label>
                                <DatePicker
                                  open={openMfgDate}
                                  onOpen={() => setOpenMfgDate(true)}
                                  onClose={() => setOpenMfgDate(false)}
                                  disableOpenPicker // ❌ disables icon click
                                  value={
                                    isProductData?.manufacturedate
                                      ? dayjs(isProductData.manufacturedate)
                                      : null
                                  }
                                  format="DD MMM YYYY"
                                  maxDate={dayjs(iso)}
                                  onChange={(newValue) => {
                                    handleMDateChange(newValue);
                                    setOpenMfgDate(false);
                                  }}
                                  slotProps={{
                                    textField: {
                                      inputRef: manufacturedateRefs,
                                      fullWidth: true,
                                      size: "small",
                                      onClick: () => setOpenMfgDate(true),
                                      onKeyDown: (e) => {
                                        if (e.key === "Enter") {
                                          handleEnterKey(
                                            e,
                                            "manufacturedate",
                                            expiredateRefs,
                                          );
                                        } else {
                                          e.preventDefault();
                                        }
                                      },
                                      // onKeyDown: (e) =>
                                      //   handleEnterKey(
                                      //     e,
                                      //     "manufacturedate",
                                      //     expiredateRefs
                                      //   ),
                                      inputProps: { readOnly: true },
                                      sx: {
                                        "& .MuiInputBase-input": {
                                          cursor: "pointer",
                                        },
                                      },
                                    },
                                    openPickerButton: {
                                      sx: { display: "none" }, //  hide icon completely
                                    },
                                  }}
                                />
                              </div>

                              <div className="col-lg-6">
                                <label
                                  htmlFor="expiredate"
                                  className="form-label"
                                >
                                  Expire Date
                                </label>
                                <DatePicker
                                  open={openExpDate}
                                  onOpen={() => setOpenExpDate(true)}
                                  onClose={() => setOpenExpDate(false)}
                                  disableOpenPicker
                                  value={
                                    isProductData?.expiredate
                                      ? dayjs(isProductData.expiredate)
                                      : null
                                  }
                                  format="DD MMM YYYY"
                                  minDate={dayjs(expireMinDate)}
                                  onChange={(newValue) => {
                                    handleEDateChange(newValue);
                                    setOpenExpDate(false);
                                  }}
                                  slotProps={{
                                    textField: {
                                      inputRef: expiredateRefs,
                                      fullWidth: true,
                                      size: "small",
                                      onClick: () => setOpenExpDate(true),
                                      onKeyDown: (e) => {
                                        if (e.key === "Enter") {
                                          handleEnterKey(
                                            e,
                                            "expiredate",
                                            productMdateRef,
                                          );
                                        } else {
                                          e.preventDefault();
                                        }
                                      },
                                      // onKeyDown: (e) =>
                                      //   handleEnterKey(
                                      //     e,
                                      //     "expiredate",
                                      //     productMdateRef
                                      //   ),
                                      inputProps: { readOnly: true },
                                      sx: {
                                        "& .MuiInputBase-input": {
                                          cursor: "pointer",
                                        },
                                      },
                                    },
                                    openPickerButton: {
                                      sx: { display: "none" },
                                    },
                                  }}
                                />
                              </div>
                            </LocalizationProvider>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="card h-100">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="mb-0">Purchase Details</h6>

                        <div className="d-flex align-items-center gap-2">
                          <span className="fw-600 ms-2 ">Add to Stock</span>

                          <div className="ms-auto custom-toggle-wrapper">
                            <label className="custom-toggle cursor-pointer">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={addToStock}
                                onChange={() => setAddToStock((prev) => !prev)}
                              />
                              <span className="slider">
                                {addToStock["stock"] ? (
                                  <span
                                    className={`spinner-inside ${
                                      addToStock["stock"] ? "spinner-right" : ""
                                    }`}
                                  />
                                ) : (
                                  <>
                                    {addToStock["stock"] ? (
                                      <span className="label-on ms-0-1"></span>
                                    ) : (
                                      <span className="label-off ms-3"></span>
                                    )}
                                  </>
                                )}
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="row g-3">
                        {/* ✅ QUANTITY + RATE SIDE BY SIDE */}
                        <div className="col-12">
                          <div className="row g-2">
                            {/* Quantity */}
                            <div className="col-md-6">
                              <label htmlFor="quantity" className="form-label">
                                Quantity <span className="text-danger">*</span>
                              </label>

                              <div className="input-group">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="quantity"
                                  autoComplete="off"
                                  ref={productMdateRef}
                                  value={isProductData.quantity}
                                  onFocus={(e) => e.target.select()}
                                  onChange={handleChange}
                                  onKeyDown={(e) => {
                                    handleEnterKey(
                                      e,
                                      "quantity",
                                      purchasewithtaxref,
                                    );
                                  }}
                                />

                                {hasUnit &&
                                  (secondaryUnitCode ? (
                                    <select
                                      className="btn btn-unit shadow-none border-end rounded-end rounded-start-0"
                                      value={selectedUnit}
                                      onChange={(e) => {
                                        const unit = e.target.value;

                                        setSelectedUnit(unit);

                                        // ✅ reset qty when switching units
                                        setProductData((prev) => ({
                                          ...prev,
                                          quantity: 0,
                                          isSecondaryUnit:
                                            unit ===
                                            selectedProduct?.unitConfig
                                              ?.secondaryUnitCode,
                                        }));
                                      }}
                                    >
                                      <option value={primaryUnitCode}>
                                        {primaryUnitCode}
                                      </option>
                                      <option value={secondaryUnitCode}>
                                        {secondaryUnitCode}
                                      </option>
                                    </select>
                                  ) : (
                                    <span className="btn btn-unit shadow-none border-end rounded-end rounded-start-0">
                                      {primaryUnitCode}
                                    </span>
                                  ))}
                              </div>

                              {error.quantity && (
                                <div className="invalid-feedback d-block">
                                  {error.quantity}
                                </div>
                              )}
                            </div>

                            {/* Rate per Unit */}
                            <div className="col-md-6">
                              <label className="form-label">
                                Rate / {(hasUnit && primaryUnitCode) || "Unit"}
                              </label>
                              <input
                                type="text"
                                disabled
                                className="form-control"
                                value={isProductData.ratePerUnit}
                                readOnly
                              />
                            </div>
                          </div>
                        </div>

                        {/* ✅ PURCHASE AMOUNT FIRST (FULL WIDTH) */}
                        <div className="col-12">
                          <label className="form-label">
                            Total Purchase Amount{" "}
                            <span className="text-danger">*</span>
                          </label>

                          <div className="row g-2">
                            {/* WITH TAX */}
                            <div className="col-md-6">
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control"
                                  ref={purchasewithtaxref}
                                  value={isProductData.purchaseWithTax}
                                  onFocus={(e) => e.target.select()}
                                  onClick={() => setPurchaseLock("WITHTAX")}
                                  name="purchaseWithTax"
                                  onChange={handleChange}
                                  style={{ paddingLeft: "30px" }}
                                  onKeyDown={(e) =>
                                    handleEnterKey(
                                      e,
                                      "purchaseWithTax",
                                      purchasewithouttaxRef,
                                    )
                                  }
                                />
                                <input
                                  type="radio"
                                  checked={purchaseLock === "WITHTAX"}
                                  onChange={() => setPurchaseLock("WITHTAX")}
                                  className="position-absolute"
                                  style={{
                                    top: "50%",
                                    left: "10px",
                                    transform: "translateY(-50%)",
                                  }}
                                />
                              </div>
                              <small>With Tax</small>
                            </div>

                            {/* WITHOUT TAX */}
                            <div className="col-md-6">
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control"
                                  ref={purchasewithouttaxRef}
                                  value={isProductData.purchaseWithoutTax}
                                  onFocus={(e) => e.target.select()}
                                  onClick={() => setPurchaseLock("WITHOUTTAX")}
                                  name="purchaseWithoutTax"
                                  onChange={handleChange}
                                  style={{ paddingLeft: "30px" }}
                                  onKeyDown={(e) => {
                                    handleEnterKey(
                                      e,
                                      "purchaseWithoutTax",
                                      null,
                                      true,
                                    );
                                  }}
                                />
                                <input
                                  type="radio"
                                  checked={purchaseLock === "WITHOUTTAX"}
                                  onChange={() => setPurchaseLock("WITHOUTTAX")}
                                  className="position-absolute"
                                  style={{
                                    top: "50%",
                                    left: "10px",
                                    transform: "translateY(-50%)",
                                  }}
                                />
                              </div>
                              <small>Without Tax</small>
                            </div>
                          </div>

                          {error.purchaseamount && (
                            <div className="invalid-feedback d-block">
                              {error.purchaseamount}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer d-block">
              <button
                type="button"
                className="btn btn-outline-secondary text-left"
                onClick={handleClose}
              >
                <XIcon/> Cancel
              </button>
              {isBtnLoading ? (
                <button className="btn btn-teal pb-0 text-right" disabled>
                  <CircularProgress size={22} className="text-white" />
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-teal text-right"
                  onClick={onAdd}
                  ref={addStockBtnRef}
                >
                  <AddIcon/> Add Item
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddStockModel;
